<template>
  <CfsAutocomplete
    v-bind="$attrs"
    :items="foundItems"
    clearable
    :return-object="false"
    :is-loading="loading"
    :multiple="multiple"
    :chips="multiple"
    v-on="$listeners"
    @update:search-input="onSearch"
  >
    <template v-for="(_, name) in $scopedSlots" #[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
  </CfsAutocomplete>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import useAutocomplete from '@/composables/useAutocomplete';
import { FilteredItemsResponse } from '@/types/service/filters.service';
import { FilterOptionServices } from '@/types/filter/filter-options';
import { FILTER_SERVICE_OPTIONS } from '@/constants/filter-options';

export default defineComponent({
  name: 'FilterOptionAutoComplete',
  props: {
    queryType: {
      type: String,
      required: true,
    },
    service: {
      type: String as PropType<FilterOptionServices>,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { foundItems, loading, onSearch } = useAutocomplete(async (query: string) => {
      const { data } = await FILTER_SERVICE_OPTIONS[props.service]<FilteredItemsResponse<any>>({
        queryType: props.queryType,
        query,
        ...props.params,
      });
      return data.data;
    }, []);

    return { foundItems, loading, onSearch };
  },
});
</script>
